$(document).ready(function () {

  if (typeof meta !== "undefined" && meta.page.pageType == "page" && window.location.pathname.includes("loading-page")) {
    // Parse the URL to extract parameters
    let params = new URLSearchParams(window.location.search);

    // ===== Meta Cookies setzen für Tracking =====
    var now = Date.now();

    // _fbc Cookie setzen (aus URL-Parameter oder aus fbclid generieren)
    var fbcParam = params.get('_fbc');
    var fbclid = params.get('fbclid');
    if (fbcParam) {
      document.cookie = '_fbc=' + fbcParam + '; max-age=7776000; path=/; SameSite=Lax';
    } else if (fbclid) {
      var fbcValue = 'fb.1.' + now + '.' + fbclid;
      document.cookie = '_fbc=' + fbcValue + '; max-age=7776000; path=/; SameSite=Lax';
    }

    // _fbp Cookie setzen (aus URL-Parameter)
    var fbpParam = params.get('_fbp');
    if (fbpParam) {
      document.cookie = '_fbp=' + fbpParam + '; max-age=7776000; path=/; SameSite=Lax';
    }
    // ===== Ende Meta Cookies =====

    let variants = [];

    // Check if there are any v_id parameters in the URL
    if (params.has('v_id') && params.has('q')) {

        fetch('/cart/clear.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => {
          if (response.ok) {

            // Loop through all parameters to find v_id and q
            for (let [key, value] of params.entries()) {
                if (key === 'v_id') {
                    let quantityKey = params.get('q');
                    variants.push({
                        id: value,
                        quantity: quantityKey
                    });
                }
            }

            // Function to add a single variant to the Shopify cart using AJAX
            function addToCart(variant) {
                return $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: {
                        id: variant.id,
                        quantity: variant.quantity
                    },
                    dataType: 'json'
                });
            }

            // Add all variants to the cart sequentially
            let ajaxCalls = variants.map(variant => addToCart(variant));

            // Wait for all AJAX calls to complete
            $.when.apply($, ajaxCalls).done(function () {
                window.location.href = '/checkout';
            }).fail(function () {
                //alert('Failed to add items to the cart. Please try again.');
            });

          }
          else {

          }
        })
        .catch(error => {
          console.error('Error:', error);
        });

    }
    else {
        // If no parameters found, redirect directly to the checkout page
        //window.location.href = '/';
    }
  }

});